import React from 'react';

const Skeleton = () => {
  return (
    <div className="flex flex-col items-center px-3">
      {/* 金额和状态部分骨架屏 */}
      <div className="text-center mt-10">
        <div className="w-32 h-8 bg-surface rounded animate-pulse mb-3"></div>
        <div className="flex items-center justify-center space-x-1">
          <div className="w-16 h-3 bg-surface rounded animate-pulse"></div>
          <div className="w-3 h-3 bg-surface rounded animate-pulse"></div>
        </div>
      </div>

      {/* 充值详情卡片骨架屏 */}
      <div className="w-[360px] h-[55px] bg-surface rounded-[8px] mt-[34px] flex items-center justify-between px-[15px]">
        <div className="w-24 h-3 bg-[#0e1113] rounded animate-pulse"></div>
        <div className="flex items-center space-x-[8px]">
          <div className="w-[26px] h-[26px] rounded-full animate-pulse"></div>
          <div className="w-20 h-4 bg-[#0e1113] rounded animate-pulse"></div>
        </div>
      </div>

      {/* 详情列表骨架屏 */}
      <div className="w-full max-w-[360px] mt-[24px] space-y-[13px]">
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className="flex justify-between items-center w-full">
            <div className="w-20 h-3 bg-surface rounded animate-pulse"></div>
            <div className="flex items-center space-x-[5px]">
              <div className="w-24 h-3 bg-surface rounded animate-pulse"></div>
              <div className="w-3 h-3 bg-surface rounded animate-pulse"></div>
            </div>
          </div>
        ))}
      </div>

      {/* 客服联系信息骨架屏 */}
      <div className="fixed bottom-[29px] left-0 right-0 flex flex-col items-center">
        <div className="text-center">
          <div className="w-48 h-3 bg-surface rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
